import styled from 'styled-components';
import { Col } from 'components/Base/Grid';

export const SCol = styled(Col)`
  margin: 24px 0;
  text-align: center;
  .countdown {
    display: inline-block;
  }
`;
